import { numberFormatCurrency } from './helpers'
import { downloadImage, downloadZipFile } from './download'
import { paymentMethods, SERVER_DATA } from '../core/constants/app'

export const discountPercent = invoice => {
	const { discount = 0 } = invoice
	return `${(discount * 100).toFixed(2)}%`
}

export const taxPercent = invoice => {
	const { taxLabor = false, taxParts = false, tax = 0 } = invoice
	if (!taxLabor && !taxParts) return `0.00%`
	return  `${(tax * 100).toFixed(2)}%`
}

export const taxTotal = invoice => {
	const {
		taxLabor = false,
		taxParts = false,
		taxLaborAmount = 0,
		taxPartsAmount = 0,
		currency,
	} = invoice
	const total = taxLabor ? taxLaborAmount : 0
	return numberFormatCurrency(
		currency,
		taxParts ? total + taxPartsAmount : total,
	)
}

export const isPaymentOffline = method => method.includes('offline')

export const paymentMethod = method => {
	const _method = isPaymentOffline(method) ? 'offline' : method
	return paymentMethods[_method] || 'other'
}

export const paymentType = method => {
	if (isPaymentOffline(method)) return 'Offline Payment:'
	if (method === 'creditcard') return 'Stripe Verified Payment:'
	return 'Payment'
}

export const getCarInfo = (vehicle = {}) => {
	const { make = '', model = '', color = '' } = vehicle
	return `${make.trim()} ${model.trim()} ${color.trim()}`.trim()
}

export const getServiceLines = (vehicle = {}) => {
	const { serviceLines = {} } = vehicle
	const serviceLinesKeys = Object.keys(serviceLines).map(e => serviceLines[e])
	const services = serviceLinesKeys.join(' ')
	return services.trim() ? services.trim() : 'Not listed'
}

export const getService = (vehicle, key) => {
	const { serviceLines = {} } = vehicle
	return serviceLines[key] || ''
}

export const getDocumentsVehicle = vehicle => {
	const { carADAS = { documents: [] } } = vehicle
	let filesDocument = []
	carADAS.documents.forEach(({ name, files }) => {
		const arr = files.map(({ fileURL }) => {
			const newUrl =
				fileURL.charAt(0) === '/'
					? fileURL.substring(1, fileURL.length)
					: fileURL
			return { fileName: name, path: `${SERVER_DATA}${newUrl}` }
		})
		filesDocument = filesDocument.concat(arr)
	})
}

export const getPhotosVehicle = vehicle => {
	const { photos = [], carADAS = { photos: [] } } = vehicle
	return [...photos, ...carADAS.photos]
}

export const downloadPhoto = photoObj => {
	downloadImage(`${SERVER_DATA}/${photoObj.url}`, photoObj.name);
}

export const downloadZipPhotos = (vehicle, callback) => {
	const photos = getPhotosVehicle(vehicle).map(({ name, url }) => {
		return {
			fileName: name, path: `${SERVER_DATA}/${url}`
		}
	})

	const zipName = getCarInfo(vehicle)
	downloadZipFile(zipName, photos)
		.then(() => {
			return callback(true)
		})
		.catch(() => {
			return callback(false)
		})
}

export const downloadPhotosRecord = (records, callback) => {
	const {
		vehicles = [],
		client: { name } = '',
		company: { name: companyName },
		number
	} = records
	let listPhoto = []
	vehicles.forEach(vehicle => {
		const photos = getPhotosVehicle(vehicle).map(({ name, url }) => {
			return { fileName: name, path: SERVER_DATA + url }
		})
		if (photos.length > 0) {
			listPhoto = listPhoto.concat(photos)
		}
	})
	downloadZipFile(name || `${companyName}${number}`, listPhoto)
		.then(() => {
			return callback(true)
		})
		.catch(() => {
			return callback(false)
		})
}

export const getPhotos = (records) => {
	const { vehicles = [] } = records
	let listPhoto = []
	vehicles.forEach(vehicle => {
		const photos = getPhotosVehicle(vehicle).map(({ name, url }) => {
			return { fileName: name, path: SERVER_DATA + url }
		})
		if (photos.length > 0) {
			listPhoto = listPhoto.concat(photos)
		}
	})
	return listPhoto
}
